(function () {
  if (window.__cartAppSyncPatched) return;
  window.__cartAppSyncPatched = true;

  var POLL_INTERVAL = 2000;
  var lastFingerprint = null;
  var checking = false;
  var pollTimer = null;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function refreshCartDrawer() {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    var sectionIds = cartDrawer.getSectionsToRender().map(function (section) {
      return section.id;
    });

    fetch('/?sections=' + sectionIds.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        cartDrawer.renderContents({ sections: sections });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fabric-meter-selector' });
        }
      })
      .catch(function (e) { console.error(e); });
  }

  function fingerprint(cart) {
    return cart.item_count + '|' + JSON.stringify((cart.items || []).map(function (item) {
      return [item.id, item.quantity, item.properties];
    }));
  }

  function checkCartOnce() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fp = fingerprint(cart);
        if (lastFingerprint !== null && fp !== lastFingerprint) {
          refreshCartDrawer();
        }
        lastFingerprint = fp;
      })
      .catch(function () {})
      .finally(function () { checking = false; });
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(checkCartOnce, POLL_INTERVAL);
  }

  function stopPolling() {
    if (!pollTimer) return;
    clearInterval(pollTimer);
    pollTimer = null;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      checkCartOnce();
      startPolling();
    } else {
      stopPolling();
    }
  });

  checkCartOnce();
  startPolling();

  // Fast path: if the app's add-to-cart call does go through window.fetch in this
  // document (not an iframe), refresh immediately instead of waiting for the next poll.
  var CART_ADD_PATTERN = /\/cart\/add(\.js)?(\?|$)/;
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var isCartAdd = method === 'POST' && CART_ADD_PATTERN.test(url);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartAdd && response.ok) {
        response
          .clone()
          .json()
          .then(function (data) {
            if (!data || data.status) return;
            checkCartOnce();
          })
          .catch(function () {});
      }
      return response;
    });
  };
})();
